import { getTimezonesForCountry } from 'countries-and-timezones';
import { getCountryCallingCode, getCountries } from 'libphonenumber-js';

/**
 * Gets the timezone for a given phone code
 * Returns undefined for countries with multiple timezones (like +1 for US/Canada)
 * @param phoneCode - The country dial code (e.g., "+91", "+44")
 * @returns Timezone string (e.g., "Asia/Kolkata") or undefined
 */
export const getTimezoneFromPhoneCode = (phoneCode: string): string | undefined => {
  if (!phoneCode) return undefined;

  try {
    // Remove '+' prefix if present
    const dialCode = phoneCode.replace(/^\+/, '');

    // Find all countries with this dial code
    const countries = getCountries();
    const matchingCountries = countries.filter(
      (country) => getCountryCallingCode(country) === dialCode
    );

    // If multiple countries share this dial code, don't auto-fill
    // (e.g., +1 is used by US, Canada, and many Caribbean nations)
    if (matchingCountries.length !== 1) return undefined;

    const countryCode = matchingCountries[0];

    // Get all timezones for this country
    const timezones = getTimezonesForCountry(countryCode);
    if (!timezones || timezones.length === 0) return undefined;

    // Only auto-fill if the country has exactly one timezone
    if (timezones.length === 1) {
      return timezones[0].name;
    }

    // For countries with multiple timezones, don't auto-fill
    return undefined;
  } catch {
    return undefined;
  }
};
